// extracted by mini-css-extract-plugin
module.exports = {"remove_contact_btn":"ContactList_remove_contact_btn__2k2HU","contact":"ContactList_contact__375jx"};